
import axios from "axios";

const state = {
  customer_purchase_orders: [],
  loading: false,
};

const getters = {
  customer_purchase_orders: (state) => state.customer_purchase_orders,
  loading: (state) => state.loading,
};

const actions = {
  async get_customer_purchase_orders({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get("customer_purchase_orders");
      commit("SET_CUSTOMER_PURCHASE_ORDERS", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching customer purchase orders:", error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async add_customer_purchase_order({ commit }, payload) {
    try {
      let formData, onUploadProgress;
      if (payload && payload._formData) {
        formData = payload._formData;
        onUploadProgress = payload.onUploadProgress;
      } else {
        formData = payload;
      }

      const isFormData = formData instanceof FormData;

      const config = isFormData
        ? {
            headers: { "Content-Type": "multipart/form-data" },
            ...(onUploadProgress ? { onUploadProgress } : {}),
          }
        : {};

      const response = await axios.post(
        "customer_purchase_order",
        formData,
        config
      );
      commit("ADD_CUSTOMER_PURCHASE_ORDER", response.data);
      return response.data;
    } catch (error) {
      console.error("Error adding customer purchase order:", error);
      throw error;
    }
  },

  async update_customer_purchase_order({ commit }, payload) {
    try {
      let formData, onUploadProgress;
      if (payload && payload._formData) {
        formData = payload._formData;
        onUploadProgress = payload.onUploadProgress;
      } else {
        formData = payload;
      }

      const isFormData = formData instanceof FormData;
      const id = isFormData ? formData.get("id") : formData.id;

      let response;
      if (isFormData) {
        response = await axios.post(`customer_purchase_order/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          ...(onUploadProgress ? { onUploadProgress } : {}),
        });
      } else {
        response = await axios.put(`customer_purchase_order/${id}`, formData);
      }

      commit("UPDATE_CUSTOMER_PURCHASE_ORDER", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating customer purchase order:", error);
      throw error;
    }
  },

  async delete_customer_purchase_order({ commit }, id) {
    try {
      await axios.delete(`customer_purchase_order/${id}`);
      commit("DELETE_CUSTOMER_PURCHASE_ORDER", id);
    } catch (error) {
      console.error("Error deleting customer purchase order:", error);
      throw error;
    }
  },

  async approve_customer_purchase_order({ commit }, id) {
    try {
      const response = await axios.put(`customer_purchase_order/${id}/approve`);
      commit("UPDATE_CUSTOMER_PURCHASE_ORDER", response.data);
      return response.data;
    } catch (error) {
      console.error("Error approving purchase order:", error);
      throw error;
    }
  },

  async disapprove_customer_purchase_order({ commit }, { id, remarks }) {
    try {
      const response = await axios.put(
        `customer_purchase_order/${id}/disapprove`,
        { remarks }
      );
      commit("UPDATE_CUSTOMER_PURCHASE_ORDER", response.data);
      return response.data;
    } catch (error) {
      console.error("Error disapproving purchase order:", error);
      throw error;
    }
  },

  async delete_attachment({ commit }, { poId, attachmentId }) {
    try {
      await axios.delete(`customer_purchase_order_attachment/${attachmentId}`);
      commit("REMOVE_ATTACHMENT", { poId, attachmentId });
    } catch (error) {
      console.error("Error deleting attachment:", error);
      throw error;
    }
  },

  async update_customer_purchase_order_item(
    { commit },
    { itemId, qty_delivered }
  ) {
    try {
      const response = await axios.put(
        `customer_purchase_order_item/${itemId}`,
        { qty_delivered }
      );
      const updatedItem =
        response.data && response.data.data
          ? response.data.data
          : response.data;
      commit("UPDATE_CUSTOMER_PURCHASE_ORDER_ITEM", updatedItem);
      return updatedItem;
    } catch (error) {
      console.error("Error updating customer purchase order item:", error);
      throw error;
    }
  },

  async forward_customer_purchase_order({ commit }, payload) {
    try {
      const response = await axios.post(
        "forward_customer_purchase_order",
        payload
      );

      if (response.data && response.data.data) {
        commit("UPDATE_CUSTOMER_PURCHASE_ORDER", response.data.data);
      }
      return response.data;
    } catch (error) {
      console.error("Error in forward_customer_purchase_order:", error);
      throw error;
    }
  },
};

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_CUSTOMER_PURCHASE_ORDERS(state, orders) {
    state.customer_purchase_orders = orders;
  },

  ADD_CUSTOMER_PURCHASE_ORDER(state, order) {
    state.customer_purchase_orders.unshift(order);
  },

  UPDATE_CUSTOMER_PURCHASE_ORDER(state, updatedOrder) {
    const index = state.customer_purchase_orders.findIndex(
      (order) => order.id == updatedOrder.id
    );
    if (index !== -1) {
      state.customer_purchase_orders.splice(index, 1, updatedOrder);
    }
  },

  REMOVE_ATTACHMENT(state, { poId, attachmentId }) {
    const order = state.customer_purchase_orders.find((o) => o.id == poId);
    if (order && order.attachments) {
      order.attachments = order.attachments.filter((a) => a.id != attachmentId);
    }
  },

  UPDATE_CUSTOMER_PURCHASE_ORDER_ITEM(state, updatedItem) {
    for (const order of state.customer_purchase_orders) {
      if (!order.items) continue;
      const index = order.items.findIndex((item) => item.id == updatedItem.id);
      if (index !== -1) {
        order.items.splice(index, 1, updatedItem);
        break;
      }
    }
  },

  DELETE_CUSTOMER_PURCHASE_ORDER(state, id) {
    state.customer_purchase_orders = state.customer_purchase_orders.filter(
      (order) => order.id != id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
